// extracted by mini-css-extract-plugin
export default {"top_container":"review_top_container__8J9lp","title":"review_title__gXUo4","hero":"review_hero__0iN8B","image_container":"review_image_container__1PKi9"};